<template>
  <vx-card no-shadow class="relative">
    <vs-row class="relative p-1 pb-0 flex-row-reverse w-auto">
      <div
        @click="$store.commit('videowiki/OPEN_JOIN_CAST_POPUP', true)"
        v-if="
          castRunningBoardsName.includes(currentUserLevelBoard.title) &&
          castInstalledBoardsName.includes(currentUserLevelBoard.title) &&
          !(
            roomRunningBoardsName.includes(currentUserLevelBoard.title) &&
            roomInstalledBoardsName.includes(currentUserLevelBoard.title)
          )
        "
        class="relative m-1 p-1 pb-0 flex live-btn w-auto cursor-pointer"
      >
        <div class="w-8">
          <object
            type="image/svg+xml"
            :data="require(`@/assets/images/user-dashboard/Cast.svg`)"
          >
            <img src="../../../../assets/images/user-dashboard/Cast.svg" />
          </object>
        </div>
        <div class="w-full ml-1">
          <p class="text-base font-semibold live-btn-text">Casting</p>
        </div>
      </div>

      <div
        v-else-if="
          roomRunningBoardsName.includes(currentUserLevelBoard.title) &&
          roomInstalledBoardsName.includes(currentUserLevelBoard.title) &&
          !(
            castRunningBoardsName.includes(currentUserLevelBoard.title) &&
            castInstalledBoardsName.includes(currentUserLevelBoard.title)
          )
        "
        @click="$store.commit('videowiki/OPEN_JOIN_ROOM_POPUP', true)"
        class="relative m-1 p-1 pb-0 flex live-btn w-auto cursor-pointer"
      >
        <div class="w-8">
          <object
            type="image/svg+xml"
            :data="require(`@/assets/images/user-dashboard/Room.svg`)"
          >
            <img src="../../../../assets/images/user-dashboard/Room.svg" />
          </object>
        </div>
        <div class="w-full ml-1">
          <p class="text-base font-semibold live-btn-text">Live</p>
        </div>
      </div>
      <div
        v-else-if="
          roomRunningBoardsName.includes(currentUserLevelBoard.title) &&
          roomInstalledBoardsName.includes(currentUserLevelBoard.title) &&
          castRunningBoardsName.includes(currentUserLevelBoard.title) &&
          castInstalledBoardsName.includes(currentUserLevelBoard.title)
        "
        @click="$store.commit('videowiki/OPEN_JOIN_ROOM_POPUP', true)"
        class="relative m-1 p-1 pb-0 flex live-btn cursor-pointer"
        style="width: 100px"
      >
        <div class="w-8 h-8 pl-1">
          <object
            class="w-6"
            type="image/svg+xml"
            :data="
              require(`@/assets/images/user-dashboard/${this.currentAnimation}`)
            "
          >
            <!-- <img type="image/svg+xml" class="transition-all" v-bind:src="
            require(`@/assets/images/user-dashboard/${this.currentAnimation}`) -->
            <!-- " /> -->
          </object>
        </div>
        <div class="w-full ml-1">
          <p v class="text-base mx-2 font-semibold live-btn-text">
            {{ iconTitle }}
          </p>
        </div>
      </div>
    </vs-row>

    <div class="items-center p-6">
      <div class="mb-4">
        <vs-avatar
          v-if="userData.profilePictureUrl"
          class="m-0"
          size="100px"
          :src="
            constants.s3Bucket +
            '/editor/profile-pictures/' +
            userData.profilePictureUrl
          "
        />
        <vs-avatar
          v-else
          class="m-0"
          size="32px"
          :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
            userData.firstName || 'boringAvatar',
            userData.lastName || 'boringAvatar'
          )}`"
        />
      </div>
      <div>
        <h3>{{ userData.firstName }} {{ userData.lastName }}</h3>
        <p class="my-4">{{ userData.email }}</p>
      </div>

      <span v-if="userVisibilityOption === 'noUsersView'">
        <h5 style="color: #b2bac8 !important" class="mr-3">
          You
          <span v-if="orgBoardUsersArray.length > 0">
            & {{ orgBoardUsersArray.length }} other people on the board</span
          >
        </h5></span
      >
      <span
        v-else-if="['usersDpView', 'talentCardView', 'resumeView'].includes(userVisibilityOption)"
      >
        <ul class="flex w-full justify-center items-center user-list">
          <h4 style="color: #b2bac8 !important" class="mr-3">
            You
            <span v-if="orgBoardUsersArray.length > 0"> &</span>
          </h4>
          <li
            v-for="(user, index) in orgBoardUsersArray.slice(0, 5)"
            :key="index"
          >
            <vx-tooltip
              class="capitalize"
              :text="`${user.userData.firstName} ${user.userData.lastName}`"
            >
              <vs-avatar
                v-if="user.userData.profilePictureUrl"
                class="-m-1 w-100"
                size="32px"
                @click="talentCardPopup(user)"
                :src="
                  constants.s3Bucket +
                  '/editor/profile-pictures/' +
                  user.userData.profilePictureUrl
                "
              />
              <vs-avatar
                v-else
                @click="talentCardPopup(user)"
                class="-m-1 w-100"
                size="32px"
                :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                  user.userData.firstName,
                  user.userData.lastName
                )}`"
              />
            </vx-tooltip>
          </li>

          <li
            class="-m-2"
            :class="this.orgBoardUsersArray.length - 5 > 0 ? 'flex' : 'hidden'"
          >
            <vs-dropdown vs-trigger-click :color="orgColor">
              <vs-avatar
                size="30px"
                :text="`+${this.orgBoardUsersArray.length - 5}`"
              />

              <vs-dropdown-menu>
                <vs-input
                  class="m-2"
                  id="vs--input"
                  :color="`${orgColor}`"
                  icon-no-border
                  icon="search"
                  icon-size="large"
                  placeholder="Search User"
                  v-model="searchValue"
                  v-on:input="searchUser()"
                  style="width: 95%"
                />

                <vs-dropdown-item
                  class="mt-0"
                  v-for="(user, index) in searchedUserArray"
                  :key="index"
                  @click="talentCardPopup(user)"
                >
                  <vs-avatar
                    v-if="user.userData.profilePictureUrl"
                    size="30px"
                    class="-m-1 mr-2"
                    @click="talentCardPopup(user)"
                    :src="
                      constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      user.userData.profilePictureUrl
                    "
                  />
                  <vs-avatar
                    v-else
                    size="30px"
                    @click="talentCardPopup(user)"
                    class="-m-1 mr-2"
                    :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      user.userData.firstName,
                      user.userData.lastName
                    )}`"
                  />
                  <p class="text-lg">
                    {{ user.userData.firstName }} {{ user.userData.lastName }}
                  </p>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </li>
        </ul>
        <!---->
      </span>

      <div
        v-if="canAccessCoach"
        class="mt-6 flex justify-center w-full"
      >
        <vs-tooltip text="Open Coach Portal">
          <div
            @click="openCoachPortal"
            class="cursor-pointer flex items-center justify-center p-2 rounded-full hover:bg-slate-100 transition-all"
          >
            <img src="@/assets/images/coach.svg" alt="Coach" class="w-10 h-10 object-contain" />
          </div>
        </vs-tooltip>
      </div>

    </div>
    <!-- <div class="relative">
      <h4
        style="color: #30384b !important"
        class="font-semibold mb-4 px-4 md:px-6"
      >
        Apps
      </h4>

      <div
        class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
        @click="showBlinkerTip"
        v-if="!blinkers.readBoardAppTip"
        ref="wrapper"
      >
        <span
          class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"
        ></span>
        <span
          class="relative inline-flex rounded-full h-full w-full blinker-color"
        ></span>
      </div>

      <div
        class="absolute blinker-details p-4 z-10"
        v-if="showBoardAppTip"
        ref="blinkerTip"
      >
        <h5>Apps work together</h5>
        <h5 class="font-semibold text-black my-2">
          “Just what you need, no more, no less”
        </h5>
        <h5>
          Apps can work together to combine and create use cases as you would
          need them.
        </h5>

        <vs-button
          class="mt-2 float-right text-black font-semibold"
          @click="readFilterDown"
          >Got It</vs-button
        >
      </div>
    </div> -->
    <!-- <div class="px-4 md:px-6" v-for="(item, index) in appSeries" :key="index">
      <div class="mb-5 cursor-pointer" @click.stop="setActiveApp(item)">
        <div
          class="p-2"
          style="border-radius: 6px"
          :style="`background: ${orgColor}`"
          :class="item === activeAppModule ? 'activeApp' : 'app--non_active'"
        >
          <div class="flex flex-wrap">
            <div class="flex items-center">
              <span
                v-if="item === activeAppModule"
                class="template-options-btn-icon inline-flex feather-icon text-primary mr-3"
                :style="[{ background: orgColor }, { 'border-radius': '10px' }]"
              >
                <img
                  :src="getAppDataById(item).icon"
                  width="40px"
                  height="40px"
                />
              </span>
              <span
                v-else
                class="template-options-btn-icon inline-flex feather-icon text-primary mr-3"
              >
                <img
                  :src="getAppDataById(item).strokeIcon"
                  width="40px"
                  height="40px"
                />
              </span>
              <h4
                class="font-medium text-xl text-left"
                :class="
                  item === activeAppModule
                    ? 'text-white'
                    : 'app--non_active-text'
                "
              >
                {{
                  item === "coach" && orgSlug !== "gala"
                    ? "Coach"
                    : getAppFlowById(item).purpose
                }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-if="boardData && boardData.description" class="mb-4 px-4 pb-4 md:px-6">
      <vs-divider />
      <div class="flex items-center justify-between">
        <h4 style="color: #30384b !important" class="font-semibold">
          Board Description
        </h4>

        <div class="flex flex-wrap gap-2">
          <div v-for="app in boardData.installedApps" v-show="getAppDataById(app) !== -1" :key="app">
            <vs-tooltip :text="getAppDataById(app).title">
              <img
                class=""
                :src="getAppDataById(app).icon"
                width="35px"
                height="35px"
                :alt="getAppDataById(app)"
              />
            </vs-tooltip>
          </div>
        </div>
      </div>
      <!-- 1000 char limits and show more to be add  -->
      <div>
        <div>
        <div
          class="mt-2 formatted-desc"
          @click.stop="handleClick"
          v-html="displayedDescription"
        ></div>
      </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import axios from "axios";
import marketplaceList from "@/assets/data/marketplace-list.js";
import appFlow from "@/assets/data/app-flow.js";
import AppStep from "./AppStep.vue";
import constants from "@/constants.js";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  name: "user-board-step",
  props: {
    installedApps: {
      type: Array,
      default: () => [],
    },
    activeApp: {
      type: String,
      default: "resume-editor",
    },
    propOrgColor: {
      type: String,
    },
  },
  components: { AppStep },
  data() {
    return {
      appFlow,
      marketplaceList,
      vTimeline: {
        icon: "CheckIcon",
        color: "primary",
      },
      constants,
      organizationConfig,
      orgColor: "",
      orgSlug: "",
      orgBoardUsersArray: [],
      searchValue: "",
      searchedUserArray: [],
      userVisibilityOption: "",
      boardUserData: {},
      openJoinCast: false,
      showBoardAppTip: false,
      interval: null,
      currentAnimation: "Room.svg",
      iconTitle: "Live",
      boardData: {},
      showMore: false,
      limit: 1000,
      canAccessCoach: false, // Default to false
      isCoachAccessChecked: false, // NEW: Prevents race conditions with API
    };
  },
  computed: {
    activeAppModule() {
      return this.$store.state.editor.activeAppModule;
    },
    userData() {
      return this.$store.state.users.data;
    },
    appSeries() {
      let _installedApps = this.installedApps.filter((value) =>
        this.appFlow.series.includes(value)
      );

      return _installedApps.sort(
        (a, b) =>
          this.appFlow.series.indexOf(a) - this.appFlow.series.indexOf(b)
      );
    },
    boardId() {
      return this.$route.params.boardId;
    },
    castInstalledBoardsName() {
      return this.$store.state.videowiki.castInstalledBoardsName;
    },
    castRunningBoardsName() {
      return this.$store.state.videowiki.castRunningBoardsName;
    },
    roomRunningBoardsName() {
      return this.$store.state.videowiki.roomRunningBoardsName;
    },
    roomInstalledBoardsName() {
      return this.$store.state.videowiki.roomInstalledBoardsName;
    },
    currentUserLevelBoard() {
      return this.$store.state.boards.currentUserLevelBoard;
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
    displayedDescription() {
      if (!this.boardData || !this.boardData.description) return "";

      function stripHtmlTags(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "";
      }
      
      const visibleText = stripHtmlTags(this.boardData.description);
      const isDescriptionLong = visibleText.length > this.limit;
      
      // FIX: If the text is shorter than the 1000 char limit, 
      // just return the raw HTML! Do not truncate or strip tags.
      if (!isDescriptionLong) {
        return this.boardData.description;
      }
      
      // If the text IS longer than the limit, setup the read more link
      const readMoreLink = '<span class="read-more-link cursor-pointer font-semibold text-primary ml-2">' +
        (this.showMore ? "read less" : "...read more") +
        "</span>";

      if (this.showMore) {
        // User clicked "...read more" -> Show full HTML formatted text
        return this.boardData.description + readMoreLink;
      } else {
        // User hasn't clicked read more -> Show plain truncated text safely 
        // (We use plain text here so we don't accidentally slice an HTML tag like <b> in half)
        const truncatedDescription = visibleText.slice(0, this.limit);
        return truncatedDescription + readMoreLink;
      }
    },
    isOverLimit() {
      return this.boardData.description.length > this.limit;
    },
  },
  watch: {
    propOrgColor(newVal) {
      if (newVal) {
        return (this.orgColor = newVal);
      }
    },
    propOrgColor(newVal) {
      if (newVal) {
        return (this.orgColor = newVal);
      }
    },
    boardId() {
      this.getBoardUsers();
    },
    appSeries(newVal) {
      newVal ? this.setActiveApp(newVal[0]) : "";
    },
  },
  methods: {
    handleClick(event) {
      const clickedElement = event.target;
      if (clickedElement.classList.contains("read-more-link")) {
        event.preventDefault(); //
        this.showMore = !this.showMore;
      }
    },
    toggleTimer() {
      if (this.currentAnimation == "Room.svg") {
        this.currentAnimation = "Cast.svg";
        this.iconTitle = "Casting";
      } else {
        this.currentAnimation = "Room.svg";
        this.iconTitle = "Live";
      }
    },
    getAppFlowById(id) {
      if (this.appFlow.flow[id]) {
        return this.appFlow.flow[id];
      } else {
        return [];
      }
    },
    getAppDataById(id) {
      const appIndex = this.marketplaceList.findIndex((app) => {
        return app.id === id;
      });
      if (appIndex !== -1) return this.marketplaceList[appIndex];
      else return appIndex;
    },
    setActiveApp(item) {
      this.$emit("setActiveApp", item);
      this.$store.dispatch("editor/activeApp", item);
    },
    getOrgDetails() {
      // Added "return" here to return the promise chain
      return this.$store
        .dispatch("boards/fetchBoardDetails", this.boardId)
        .then((res) => {
          this.boardData = res.data; 
          this.orgId = res.data.orgData._id;
          this.orgColor = res.data.orgData.primaryThemeColor;
          this.orgSlug = res.data.orgData.slug;
          this.boardName = res.data.title;
          
          // ADD THIS LINE to save the visibility option:
          this.userVisibilityOption = res.data.userVisibilityOption;
          
          // Added "return" so mounted() waits for the coach checks to fully complete
          return this.checkCoachAccess();
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    getBoardUsers() {
      // this.$vs.loading();
      this.searchedUserArray = [];
      this.$store
        .dispatch("boards/fetchAllBoardUsers", this.boardId)
        .then((res) => {
          if (res.data) {
            this.orgBoardUsersArray = JSON.parse(JSON.stringify(res.data));
            let i;
            for (i = 0; i < res.data.length; i++) {
              if (this.userData && this.userData._id === res.data[i].userId) {
                this.orgBoardUsersArray.splice(i, 1);
                this.$vs.loading.close();
                this.searchedUserArray = this.orgBoardUsersArray;
                return this.orgBoardUsersArray;
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    talentCardPopup(data) {
      if (
        this.userVisibilityOption === "talentCardView" ||
        this.userVisibilityOption === "resumeView"
      ) {
        this.$emit("openProfileCardPopup", {
          ...data,
          ...this.userVisibilityOption,
        });
      }
      // this.$emit("openProfileCardPopup", data);
    },
    // boxShadowChange(color) {
    //   var obj = document.getElementById("vs--input");
    //   obj.style.boxShadow = `0 3px 10px 0 ${color}`;
    // },
    searchUser() {
      if (this.searchValue) {
        this.searchedUserArray = this.orgBoardUsersArray.filter((user) => {
          if (user.userData.firstName && user.userData.lastName) {
            return (
              user.userData.firstName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              user.userData.lastName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          } else if (user.userData.firstName) {
            return user.userData.firstName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          } else if (user.userData.lastName) {
            return user.userData.lastName
              .toLowerCase()
              .includes(this.searchValue.toLowerCase());
          }
        });
        return;
      } else {
        return (this.searchedUserArray = this.orgBoardUsersArray);
      }
    },
    readFilterDown() {
      this.showBoardAppTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", {
        status: true,
        key: "readBoardAppTip",
      });
    },
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;

      if (!popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showBoardAppTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showBoardAppTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
    async checkCoachAccess() {
      // 1. Validate context presence
      if (!this.orgId || !this.userData || !this.userData._id || !this.boardId) {
        return;
      }

      const pythonApiUrl = process.env.VUE_APP_API_URL;
      
      try {
        // 2. Fetch coach/succession plans strictly mapped in the database
        const plansRes = await axios.get(`${pythonApiUrl}/api/v2/coach-plans/${this.orgId}`);
        
        let isSuccessionBoard = false;

        if (plansRes.data && plansRes.data.status === "success") {
          const plans = plansRes.data.data;
          
          // STRICT CHECK: Does THIS exact boardId exist inside a succession plan 
          // AND is the current user successfully assigned to it?
          isSuccessionBoard = plans.some(plan => {
            const assignedUsers = plan.assigned_users || [];
            return plan.board_id === this.boardId && 
                   (assignedUsers.includes(this.userData.email) || assignedUsers.includes(this.userData._id));
          });
        }
        
        // 3. Fallback Check: Did the admin explicitly mark this as a Coach Board?
        const isStructurallyCoach = this.boardData && 
          (this.boardData.isCoach === true || (this.boardData.slug && this.boardData.slug.includes('coach')));

        // 4. Set the final truth value
        this.canAccessCoach = isSuccessionBoard || isStructurallyCoach;
        this.isCoachAccessChecked = true; // Mark API check as completed

        if (!this.canAccessCoach) {
          return; // Stop here! The icon will stay hidden.
        }
        
        // 5. If it IS a coach board, check relationships to set role (Coach vs Trainee)
        const res = await axios.get(`${pythonApiUrl}/api/v2/organization/${this.orgId}/user/${this.userData._id}/is-coach`);
        
        if (res.data) {
          if (res.data.is_coach) {
            this.detectedCoachRole = "coach";
          } else {
            this.detectedCoachRole = "trainee";
          }
        }

      } catch (e) {
        console.warn("Coach access check failed", e);
        this.canAccessCoach = false;
        this.isCoachAccessChecked = true;
      }
    },
    async openCoachPortal() {
      this.$vs.loading();
      const coachApi = "https://api.coach.getboarded.com"; // Replace with your FeathersJS API URL
      const pythonApiUrl = process.env.VUE_APP_API_URL || "https://api.getboarded.tech";
      
      try {
        // --- 1. AWAIT EXACT ROLE DIRECTLY FROM PYTHON ---
        const roleRes = await axios.get(`${pythonApiUrl}/api/v2/organization/${this.orgId}/user/${this.userData._id}/is-coach`);
        
        let currentRole = "trainee"; 
        if (roleRes.data && roleRes.data.is_coach) {
          currentRole = "coach";
        }

        console.log(`[SYNC] Python API says user should be: ${currentRole}`);

        // --- 2. DIRECT SYNC WITH COACH FEATHERS API (MYSQL) ---
        const checkRes = await axios.get(`${coachApi}/users?email=${this.userData.email}`);
        
        let currentMysqlId = null;

        if (checkRes.data && checkRes.data.total === 0) {
          // A. User missing! Create them
          const newUserPayload = {
            email: this.userData.email,
            firstName: this.userData.firstName || "User", // FIXED to camelCase
            lastName: this.userData.lastName || "",       // FIXED to camelCase
            username: this.userData.email.split("@")[0],
            userType: currentRole,                        // FIXED to camelCase
            password: Math.random().toString(36).slice(-8) + "A1!", 
            status: "active",
            flag: "sso" 
          };
          
          const createRes = await axios.post(`${coachApi}/users`, newUserPayload);
          currentMysqlId = createRes.data.id;
          console.log(`[SYNC] Created new user in Coach DB as: ${currentRole}`);
          
        } else if (checkRes.data && checkRes.data.total > 0) {
          // B. User EXISTS! 
          const existingUser = checkRes.data.data[0];
          currentMysqlId = existingUser.id;
          
          // FIXED: We must check existingUser.userType (camelCase)
          if (currentRole === 'coach' && existingUser.userType !== 'coach') {
            await axios.patch(`${coachApi}/users/${currentMysqlId}`, {
              userType: 'coach', // FIXED to camelCase
              flag: 'sso'
            });
            console.log("[SYNC] Upgraded existing user to Coach in MySQL DB");
          } else {
            console.log("[SYNC] User role already matches MySQL.");
          }
        }

        // --- 3. MAP TRAINEES TO COACH ---
        if (currentRole === 'coach' && currentMysqlId) {
          await this.syncTraineeCoachTable(currentMysqlId, coachApi, pythonApiUrl);
        }

        // --- 4. GENERATE MAGIC LINK & AUTO-LOGIN ---
        const linkRes = await this.$store.dispatch("auth/generateMagicLink", {
          email: this.userData.email,
          loginCode: "1234", 
          redirectTo: "https://coach.getboarded.com", 
        });
        
        if (linkRes && linkRes.data && linkRes.data.invitePhrase) {
          let url = `${coachApi}/oauth-auto?invitePhrase=${encodeURIComponent(linkRes.data.invitePhrase)}`;
          window.open(url, "_blank");
        }
        
      } catch (err) {
        console.error("Coach Access Error:", err);
        this.$vs.notify({
          title: 'Access Denied',
          text: 'Could not connect to the Coach portal at this time.',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    // --- HELPER FUNCTION TO MAP TRAINEES IN MYSQL ---
    async syncTraineeCoachTable(coachMysqlId, coachApiUrl, pythonApiUrl) {
      try {
        // 1. Get relationships from Python API
        const relRes = await axios.get(`${pythonApiUrl}/api/v2/organization/${this.orgId}/user/${this.userData._id}/relationships`);
        
        if (relRes.data && relRes.data.data) {
          const relationships = relRes.data.data;
          
          for (let rel of relationships) {
            // Only proceed if the relationship is "Coach"
            if (rel.label && rel.label.toLowerCase() === "coach") {
              
              let traineeEmail = null;
              
              // Safely grab the trainee's email.
              if (rel.userData && rel.userData.email) {
                traineeEmail = rel.userData.email;
              } else {
                const traineeUserRes = await axios.get(`${pythonApiUrl}/api/users/${rel.other_user_id}`);
                if (traineeUserRes.data && traineeUserRes.data.data) {
                  traineeEmail = traineeUserRes.data.data.email;
                }
              }

              if (traineeEmail) {
                // 2. Find the Trainee's MySQL ID
                const traineeRes = await axios.get(`${coachApiUrl}/users?email=${traineeEmail}`);
                
                if (traineeRes.data && traineeRes.data.total > 0) {
                  const traineeMysqlId = traineeRes.data.data[0].id;

                  // 3. Check if mapping already exists exactly between YOU and this TRAINEE
                  const mappingCheck = await axios.get(`${coachApiUrl}/trainee-coach?coachId=${coachMysqlId}&traineeId=${traineeMysqlId}`);
                  
                  if (mappingCheck.data && mappingCheck.data.total === 0) {
                    try {
                      // 4. Safely attempt to create the mapping!
                      await axios.post(`${coachApiUrl}/trainee-coach`, {
                        coachId: coachMysqlId,
                        traineeId: traineeMysqlId,
                        status: "active"
                      });
                      console.log(`[SYNC] Mapped Trainee (${traineeEmail}) to Coach`);
                    } catch (mappingErr) {
                      // IF MYSQL REJECTS IT (e.g., unique violation because they have an old coach)
                      console.warn(`[SYNC] Skipped mapping for ${traineeEmail}. They may already have a coach assigned in the DB.`);
                      
                      // OPTIONAL: If you want to OVERWRITE their old coach and steal the trainee:
                      /*
                      if (mappingErr.response && mappingErr.response.status === 400) {
                        // Find their old row
                        const oldMapping = await axios.get(`${coachApiUrl}/trainee-coach?traineeId=${traineeMysqlId}`);
                        if (oldMapping.data && oldMapping.data.total > 0) {
                           // Patch their row to point to YOU instead
                           await axios.patch(`${coachApiUrl}/trainee-coach/${oldMapping.data.data[0].id}`, {
                             coachId: coachMysqlId
                           });
                           console.log(`[SYNC] Reassigned Trainee (${traineeEmail}) to you.`);
                        }
                      }
                      */
                    }
                  } else {
                    console.log(`[SYNC] Trainee (${traineeEmail}) is already mapped to you.`);
                  }
                } else {
                  console.warn(`[SYNC] Trainee ${traineeEmail} hasn't logged into Coach DB yet. Will map when they do.`);
                }
              }
            }
          }
        }
      } catch (e) {
        console.warn("[SYNC] Failed to map trainee-coach relationships", e);
      }
    },
  },
  async mounted() {
    // 1. Fetch board details and finish the coach checks first
    await this.getOrgDetails();
    
    // 2. Only start loading users after the coach check is complete
    this.getBoardUsers();
  },
  created() {
    if (this.interval == null) {
      this.interval = setInterval(this.toggleTimer, 3000);
    }
    this.setActiveApp(this.appSeries[0]);
  },
};
</script>

<style lang="scss" scoped>
.app {
  &--non_active {
    background: #ffffff !important;
    border: 1px solid #dfe3eb;
    border-radius: 6px;
  }

  &--non_active-text {
    color: #798ba0 !important;
  }
}

.live-btn {
  right: 0.5em;
  top: 0.5em;
  border: 2px solid #7367f0;
  border-radius: 8px;

  &-text {
    color: #7367f0 !important;
  }
}
.blinker {
  top: 1em;
  left: 5em;
  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }
  &-details {
    background: #fae0a0;
    right: -2.5em;
    top: 2.5em;
    width: 25em;
    border-radius: 8px;
  }
}
</style>

<style scoped>
.vs-dropdown--item >>> .vs-dropdown--item-link {
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  padding-left: 1em;
  padding-right: 2em;
}

.con-vs-dropdown--menu {
  max-height: 20em;
  height: auto !important;
  overflow-y: scroll;
}

.con-vs-dropdown--menu::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.con-vs-dropdown--menu::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(128, 128, 128, 0.378);
  /* border-radius: 10px; */
}

/* Handle */
.con-vs-dropdown--menu::-webkit-scrollbar-thumb {
  background: rgba(199, 195, 195, 0.658);
  border-radius: 10px;
}

.vs-input >>> .vs-input--icon {
  font-size: 1.5rem;
  color: #97a4bf !important;
}

.vs-input >>> .vs-input--input {
  box-shadow: none;
}

.con-vs-avatar >>> .vs-avatar--text {
  font-size: 1.5rem;
}

.vx-card >>> .vx-card__body {
  padding: 0 !important;
}

.formatted-desc {
  color: #9caabd;
  font-size: 1rem;
  font-weight: 400;
}

.formatted-desc >>> b, 
.formatted-desc >>> strong {
  font-weight: bold !important;
}

.formatted-desc >>> i, 
.formatted-desc >>> em {
  font-style: italic !important;
}

.formatted-desc >>> u {
  text-decoration: underline !important;
}

.formatted-desc >>> s {
  text-decoration: line-through !important;
}

.formatted-desc >>> ul {
  list-style-type: disc !important;
  padding-left: 1.5em !important;
  margin: 1em 0 !important;
}

.formatted-desc >>> ol {
  list-style-type: decimal !important;
  padding-left: 1.5em !important;
  margin: 1em 0 !important;
}

.formatted-desc >>> blockquote {
  border-left: 4px solid #ccc !important;
  padding-left: 1em !important;
  margin: 1em 0 !important;
}
</style>
